import React from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import FeedbackChain from './models/FeedbackChain';
import {SplitButton, MenuItem} from 'react-bootstrap';


@injectIntl @inject('authorizationsStore')  @observer
export default class StatesToolbar extends React.Component{


    render(){
        const {feedbackChain, intl} = this.props;
        const states = Object.values(FeedbackChain.states);
        return (
            <div className={'toolbar feedback-chain-states'}>
                <div className={'title'}><i className="fa fa-ellipsis-h" />&nbsp;
                    {intl.formatMessage({id:"states_title"})}
                </div>
                <div className={'content'}>
                    <SplitButton
                        bsStyle={'default'}
                        title={intl.formatMessage({id: feedbackChain.state})}
                        key={feedbackChain.state}
                        id={`split-button-basic-${feedbackChain.state}`}
                        disabled={!this.props.authorizationsStore.canEditFeedback(feedbackChain)}
                    >
                        {states.map( (s, idx) =>
                            <MenuItem key={idx} className={s} eventKey={s} onSelect={(k) => feedbackChain.setState(k)}>
                                {intl.formatMessage({id: s})}
                            </MenuItem>
                        )}
                    </SplitButton>
                </div>
            </div>
        );
    }
}